import React, { useEffect, useState } from "react";
import CloseIcon from "@material-ui/icons/Close";
import {
  Dialog,
  DialogContent,
  Slide,
  DialogTitle,
  IconButton,
  useTheme,
} from "@material-ui/core";

import { ReactComponent as CompletedIconSvg } from "../../../assets/icons/completed-2.svg";

import { FORMAT_APY, expandFixed } from "../constants/constants";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { withStyles } from "@material-ui/core/styles";
import Button from "./Button";
import SliderBar from "./SliderBar";
import Spinner from "./Spinner";
import { toFixed } from "../../../constants/constants";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  waitingForConfirmationContainer: {
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    margin: "auto",
    marginTop: "62px",
  },
  completedIcon: {
    height: "120px",
    width: "120px",
    color: "#00bb1c",
  },
  waitingForConfirmationText: {
    color: theme?.colors?.presale?.cardTitle,
    fontWeight: "600",
    fontSize: "24px",
    marginTop: "32px",
  },

  manageModalContent: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "34px !important",
    padding: "32px 48px 24px 48px",
    position: "relative",
    height: "430px",
  },

  paper: {
    background: theme?.colors?.swap?.background,
    borderRadius: "30px",
    boxShadow:
      "0px 10px 60px " + theme?.colors?.containerShadow + " !important",
  },
  modalRoot: {
    maxWidth: "640px",
    [theme.breakpoints.up("md")]: {
      borderRadius: "30px",
    },
  },
  manageModalBody: {
    zIndex: 1,
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "20px",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  manageModalNameInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "10px 0px",
  },
  manageModalHeadingMd: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "uppercase",
    marginBottom: "10px",
  },

  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1,
    width: "100%",
  },
  modalHeadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    padding: "8px 24px 0px",
  },
  modalHeadingLogoName: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  modalLg: {
    maxWidth: "553px",
  },
  modalHeadingLogo: {
    width: "35px",
    height: "35px",
    objectFit: "contain",
    marginRight: "5px",
  },
  modalHeadingLg: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "25px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    textTransform: "capitalize",
    fontWeight: 600,
  },
  modalCloseIcon: {
    width: "28px",
    height: "28px",
    position: "absolute",
    top: "25px",
    right: "25px",
    color: theme?.colors?.presale?.cardTitle,
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
  buttonsContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginTop: "auto",
    // marginTop: "48px",
    // [theme.breakpoints.down("sm")]: {
    //   marginTop: "24px",
    // },
  },
  manageModalText: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    marginBottom: "20px",
  },
  manageModalSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    height: "65px",
    marginBottom: "40px",
  },
  manageModalHeadingSm: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  manageModalNameId: {
    padding: "10px 20px 6px 20px",
    background: "#A0A0A0 0% 0% no-repeat padding-box",
    borderRadius: "8px",
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  manageModalSell: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    padding: "10px 0px",
  },
  stakingModalBody: {
    zIndex: 1,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingInfoList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "0px 15px",
  },
  stakingHeading: {
    display: "flex",
    width: "100%",
    marginBottom: "15px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingLine: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  stakingIndex: {
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
  },
  stakingValue: {
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingModeContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "35px",
    gap: "38px",
  },
  stakingModeLabel: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "27px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
  },
  stakingModeLabelSelected: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "27px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    borderBottom: "2px solid " + theme?.colors?.presale?.cardTitle,
  },
  stakingInputContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginBottom: "20px",
  },
  stakingLockContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  stakingLockLabelValues: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  stakingLabel: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
  },
  stakingLabelBold: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
  },
  stakingLockSlider: {
    width: "100%",
    marginBottom: "50px",
  },
  stakingAmountInputBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  stakingAmountLabels: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  textInput: {
    background: "transparent",
    border: "2px solid" + theme?.colors?.createPool?.inputBorder,
    color: theme?.colors?.createPool?.inputLabel,

    width: "100%",
    borderRadius: "20px",
    padding: "16px",
  },
  stakingAmountLine: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    marginBottom: "10px",
  },
  stakingMaxButton: {
    position: "absolute",
    right: "16px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
    "&:hover": {
      color: theme?.colors?.presale?.cardTitle,
    },
  },
  stakingAmountApy: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: "20px",
  },
  stakingTipText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "15px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    maxWidth: "240px",
  },
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

const StakingModal = ({
  modalOpen,
  onClose,
  pool,
  onStake,
  onApprove,
  isLoading,
  showSuccessModal,
  classes,
}) => {
  const theme = useTheme();
  const [lockOrLiquid, setLockOrLiquid] = useState(true);
  const [stakeAmount, setStakeAmount] = useState("0");
  const [lockPeriod, setLockPeriod] = useState(8);
  const [lockWeight, setLockWeight] = useState(2);
  // const [apyValue, setApyValue] = useState(945);

  useEffect(() => {
    setLockWeight(lockPeriod / 52 + 1);

    // if (lockOrLiquid) {
    //   setApyValue(parseFloat(pool?.apy) / 10);
    // } else {
    //   setApyValue(
    //     (parseFloat(pool?.apy) / 2) * parseFloat(lockPeriod / 52 + 1)
    //   );
    // }
  }, [lockOrLiquid, lockPeriod, pool]);

  return (
    <Dialog
      classes={{ paper: classes.paper, paperWidthSm: classes.modalRoot }}
      open={modalOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="staking-modal-title"
      aria-describedby="staking-modal-description"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <div className={classes.modalHeadingContainer}>
          <div className={classes.modalHeadingLogoName}>
            <img
              src={`/tokens/${pool?.token?.address}.png`}
              alt="logo"
              className={classes.modalHeadingLogo}
            />
            <span className={classes.modalHeadingLg}>
              Stake {pool?.token?.symbol}
            </span>
          </div>
        </div>
        <IconButton
          aria-label="close"
          className={classes.modalCloseIcon}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className={classes.manageModalContent}>
        {showSuccessModal ? (
          <div className={classes.waitingForConfirmationContainer}>
            <CompletedIconSvg className={classes.completedIcon} />

            <p className={classes.waitingForConfirmationText}>
              Transaction completed
            </p>

            <div className={classes.buttonsContainer}>
              <Button
                classes={{
                  root: classes.poolButton,
                  label: classes.buttonLabel,
                }}
                onClick={onClose}
                text="Close"
              />
            </div>
          </div>
        ) : isLoading ? (
          <div className={classes.waitingForConfirmationContainer}>
            <Spinner />
            <p className={classes.waitingForConfirmationText}>
              Waiting for confirmation
            </p>

            <div className={classes.buttonsContainer}>
              <Button
                classes={{
                  root: classes.poolButton,
                  label: classes.buttonLabel,
                }}
                onClick={onClose}
                text="Close"
              />
            </div>
          </div>
        ) : (
          <>
            <div className={classes.stakingModeContainer}>
              <div
                className={`${classes.stakingModeLabel} ${
                  lockOrLiquid ? classes.stakingModeLabelSelected : ""
                }`}
                onClick={() => setLockOrLiquid(true)}
                aria-hidden="true"
              >
                Liquid
              </div>
              <div
                className={`${classes.stakingModeLabel} ${
                  !lockOrLiquid ? classes.stakingModeLabelSelected : ""
                }`}
                onClick={() => setLockOrLiquid(false)}
                aria-hidden="true"
              >
                Locked
              </div>
            </div>
            <div className={classes.stakingInputContainer}>
              {!lockOrLiquid && (
                <div className={classes.stakingLockContainer}>
                  <div className={classes.stakingLockLabelValues}>
                    <span className={classes.stakingLabel}>
                      Lock for:{" "}
                      <span className={classes.stakingLabelBold}>
                        {lockPeriod} weeks
                      </span>
                    </span>
                    <span className={classes.stakingLabel}>
                      Weight:{" "}
                      <span className={classes.stakingLabelBold}>
                        {lockWeight.toFixed(2)}
                      </span>
                    </span>
                  </div>
                  <div className={classes.stakingLockSlider}>
                    <SliderBar
                      color={theme?.colors?.wallet?.buttonBackground}
                      tipFormatter={(_value) => `${_value} weeks`}
                      value={lockPeriod}
                      onChange={setLockPeriod}
                      min={8}
                      max={52}
                    />
                  </div>
                </div>
              )}
              <div className={classes.stakingAmountInputBox}>
                <div className={classes.stakingAmountLabels}>
                  <span className={classes.stakingLabel}>Amount</span>
                  <span className={classes.stakingLabel}>
                    Balance:{" "}
                    <span className={classes.stakingLabelBold}>
                      {toFixed(pool?.balance, pool?.token?.decimals, 6) || 0}{" "}
                      {/* {pool?.token?.symbol} */}
                    </span>
                  </span>
                </div>
                <div className={classes.stakingAmountLine}>
                  <input
                    className={classes.textInput}
                    type="text"
                    label=""
                    value={stakeAmount} // Use a state variable to hold the user's input as a string
                    onChange={(ev) => {
                      const input = ev.target.value;

                      var maxDigits = pool?.token?.decimals || 18;

                      var regex = new RegExp(
                        "^\\d*\\.?\\d{0," + maxDigits + "}$"
                      );

                      if (regex.test(input)) {
                        setStakeAmount(input); // Update the stakeAmount state with the new input
                      }
                    }}
                  />
                  <div
                    className={classes.stakingMaxButton}
                    onClick={() =>
                      setStakeAmount(
                        toFixed(pool?.balance, pool?.token?.decimals, 6) || "0"
                      )
                    }
                    aria-hidden="true"
                  >
                    Max
                  </div>
                </div>
                <div className={classes.stakingAmountApy}>
                  <span className={classes.stakingLabel}>
                    Est. APY:{" "}
                    <span className={classes.stakingLabelBold}>
                      {FORMAT_APY(pool?.apy || 0) || 0}%
                    </span>
                  </span>
                </div>
              </div>
            </div>
            {pool?.approved ? (
              <div className={classes.buttonsContainer}>
                <Button
                  classes={{
                    root: classes.poolButton,
                    label: classes.buttonLabel,
                  }}
                  disabled={stakeAmount <= 0}
                  onClick={() => {
                    if (
                      parseFloat(stakeAmount) > 0 &&
                      parseFloat(stakeAmount) <= parseFloat(pool?.balance)
                    ) {
                      // convert stakeAmount to wei before passing it to onStake
                      const stakeAmountInWei = expandFixed(
                        stakeAmount,
                        pool?.token?.decimals
                      ).toString();

                      if (lockOrLiquid) {
                        onStake(stakeAmountInWei, 0);
                      } else {
                        const currentTimestamp = Date.now() / 1000;
                        onStake(
                          stakeAmountInWei,
                          parseInt(currentTimestamp) + 604800 * lockPeriod
                        );
                      }
                    }
                  }}
                  text={lockOrLiquid ? "Stake" : "Lock"}
                />
              </div>
            ) : (
              <div className={classes.buttonsContainer}>
                <Button
                  classes={{
                    root: classes.poolButton,
                    label: classes.buttonLabel,
                  }}
                  onClick={() => {
                    onApprove();
                  }}
                  text="Approve"
                />
              </div>
            )}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(StakingModal)));
